import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const CountryContext = createContext(null);

export function CountryProvider({ children }) {
  const [countries, setCountries] = useState([]);
  const [current, setCurrent] = useState(localStorage.getItem("bsg_country") || "CM");

  useEffect(() => {
    api.get("/countries").then((r) => setCountries(r.data)).catch(() => {});
  }, []);

  const setCountry = (code) => {
    localStorage.setItem("bsg_country", code);
    setCurrent(code);
  };

  const active = countries.filter((c) => c.active);
  const currentCountry = countries.find((c) => c.code === current);

  return (
    <CountryContext.Provider value={{ countries, active, current, currentCountry, setCountry }}>
      {children}
    </CountryContext.Provider>
  );
}

export const useCountry = () => useContext(CountryContext);
